import { hash } from "../shared";

export default function getNodeCacheKey(
  initDataHash: string,
  nodePath: string,
  suffix: string
): string {
  return hash(`${initDataHash}/${nodePath}/${suffix}`).toString();
}
